import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import VeiculosLogged from '../../../components/auth/veiculos'

function VeiculosLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo da Frota Municipal" />
                <HeaderLogged />
                <Container>
                   <VeiculosLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default VeiculosLoggedScreen;